var NotificationIconState =
{
    OUTLINE: 0,
    FILLED: 1,
    FILLEDWITHDOT: 2
};

var NotificationType =
{
    RECOMMENDEDJOB: "Recommended Job",
    JBEUPDATE: "JBE Update"
}

var SourceOfNotification =
{
    POPUPPANEL: "aoqsnptrzefyws",
    NOTIFICATIONPAGE: "borsmpuraegyxs"
}

function NotificationItem(notificationType, link, title, subtitle, body, dateCreated) {

    this.notificationType = notificationType;
    this.link = link;
    this.title = title;
    this.subtitle = subtitle;
    this.body = body;
    this.dateCreated = dateCreated;

    this.isExpired = function () {
        if (typeof this.dateCreated !== "undefined" && this.dateCreated !== null)
        {

            var daysSinceLastPosted = ((new Date()).getTime() - this.dateCreated.getTime()) / (1000 * 3600 * 24);
            if (daysSinceLastPosted > this.lifeTimeInDays())
            {
                return true;
            }

        }
        return false;
    }

    this.lifeTimeInDays = function () {

        return (this.notificationType === NotificationType.JBEUPDATE) ? 7 : 30;

    }

    this.addNotificationQueryStringToUrl = function (queryStringValueForTheSourceOfNotification, position) {

        if (this.notificationType === NotificationType.JBEUPDATE)
        {
            return this.link;
        }
        var pageName = "unknown";
        var queryStringParameterNameForTheSourceOfNotification = "src_notifications";
        if (typeof analytics !== "undefined" && analytics !== null) {
            if (typeof analytics.RecommendedJobsOrigin !== "undefined" && analytics.RecommendedJobsOrigin !== null) {
                pageName = analytics.RecommendedJobsOrigin;
            }
            else if (typeof analytics.PageName !== "undefined" && analytics.PageName !== null) {
                pageName = analytics.PageName;
            }
        }

        var positionAndPageName = position + "|" + pageName;
        var conjunction = "?";
        if (this.link.indexOf("?") > -1) {
            conjunction = "&";
        }
        return this.link + conjunction + queryStringParameterNameForTheSourceOfNotification + "=" + queryStringValueForTheSourceOfNotification + "&r=" + positionAndPageName;

    }
}

function RecommendedJobNotification(link, title, subtitle, body, dateCreated) {

    NotificationItem.call(this, NotificationType.RECOMMENDEDJOB, link, title, subtitle, body, dateCreated);

    this.displayInNotificationPanel = function ()
    {
        return '<div class="notification">' +
            '<div class="notification-content">' +
            '<span class="notification-prompt">Recommended job</span>' +
            '<span class="notification-title block-ellipsis">' +
            this.title +
            '</span>' +
            '<span class="notification-subtitle">' +
            (this.subtitle || " ") +
            '</span>' +
            '<span class="notification-text block-ellipsis">' +
            (this.body || " ") +
            '</span>' +
            '</div>' +
            "</div>";
    }

    this.displayOnNotificationPage = function () {
        return "<div class=\"row\">" +
            "<div class=\"notification-page-notification-details col-xs-12\"\>" +
            "<p class=\"notification-page-notification-type\">Recommended job</span>" +
            "</p>" +
            "<p class=\"notification-page-notification-title\">" +
            this.title +
            "</p>" +
            ((this.subtitle !== "")
                ? "<p class=\"notification-page-notification-infoMessage\">" +
                this.subtitle +
                "</p>"
                : "") +
            "<p class=\"notification-page-notification-text\">" +
            (this.body || " ") +
            "</p>" +
            "</div>" +
            "</div>";
    }

}

function JbeUpdateNotification(link, title, subtitle, body, dateCreated) {

    NotificationItem.call(this, NotificationType.JBEUPDATE, link, title, subtitle, body, dateCreated);

    this.displayInNotificationPanel = function ()
    {
        return '<div class="notification">' +
            '<div class="notification-icon jbe-update-notification-icon" >' +
            this.icon(50, 5, 50) +
            '</div>' +
            '<div class="notification-content jbe-update-notification-content">' +
            '<span class="notification-prompt">Email alerts</span>' +
            '<span class="jbe-update-notification-title">' +
            this.title +
            '</span>' +
            '<span class="jbe-update-notification-body">' +
            (this.body || " ") +
            '</span>' +
            '</div>' +
            '</div>';
    }

    this.displayOnNotificationPage = function () {
        return "<div class=\"row\">" +
            "<div class=\"notification-page-notification-details col-xs-1\"\>" +
            this.icon(60, -5, 40) +
            "</div>" +
            "<div class=\"notification-page-notification-details col-xs-11\"\>" +
            "<p class=\"notification-page-notification-type\">Email alerts</p>" +
            "<p class=\"jbe-update-notification-page-title\">" +
            this.title +
            "</p>" +
            "<p class=\"jbe-update-notification-page-body\">" +
            (this.body || " ") +
            "</p>" +
            "</div>" +
            "</div>";
    }

    this.icon = function (width, corner, viewBoxWidth) {
        return '<svg width="' + width + 'px" height="' + width + 'px" viewBox="' + corner + ' ' + corner + ' ' + viewBoxWidth + ' ' + viewBoxWidth + '" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns: xlink="http://www.w3.org/1999/xlink">' +
            '<g id="Alerts" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">' +
            '<g id="Group-7" transform="translate(6.000000, 9.000000)">' +
            '<g id="Group-6">' +
            '<g id="Group-4" transform="translate(12.158300, 8.250000)">' +
            '<path d="M11.9042,5.4098 L13.0834,4.7289 L11.4334,1.8711 L10.2443,2.5575 C9.6613,2.0229 8.9639,1.6247 8.1917,1.3794 L8.1917,-3.46389584e-14 L4.8917,-3.46389584e-14 L4.8917,1.3794 C4.1195,1.6247 3.4221,2.0229 2.8391,2.5575 L1.65,1.8711 L-1.50990331e-14,4.7289 L1.1792,5.4098 C0.9966,6.2326 0.9955,6.9641 1.1792,7.7913 L0.0022,8.4711 L1.6522,11.3289 L2.8391,10.6436 C3.4221,11.1771 4.1195,11.5753 4.8917,11.8206 L4.8917,13.2 L8.1917,13.2 L8.1917,11.8206 C8.9639,11.5753 9.6613,11.1771 10.2443,10.6436 L11.4312,11.3289 L13.0812,8.4711 L11.9042,7.7913 C12.0879,6.9641 12.0868,6.2326 11.9042,5.4098 L11.9042,5.4098 Z" id="Stroke-611" fill="#CCCCCC"></path>' +
            '<path d="M8.7417,6.6 C8.7417,7.8144 7.7572,8.8 6.5417,8.8 C5.3273,8.8 4.3417,7.8144 4.3417,6.6 C4.3417,5.3856 5.3273,4.4 6.5417,4.4 C7.7572,4.4 8.7417,5.3856 8.7417,6.6 L8.7417,6.6 Z" id="Stroke-612" stroke="#000000" stroke-width="1.1" fill="#FFFFFF" stroke-linejoin="round"></path>' +
            '</g>' +
            '<path d="M9.9,15.4 L1.6214,15.4 C0.7106,15.4 -4.61852778e-14,14.6608 -4.61852778e-14,13.75 L-4.61852778e-14,1.65 C-4.61852778e-14,0.7381 0.7106,-1.24344979e-14 1.6214,-1.24344979e-14 L21.4214,-1.24344979e-14 C22.3322,-1.24344979e-14 23.1,0.7381 23.1,1.65 L23.1,6.6" id="Stroke-613" stroke="#000000" stroke-width="1.1" stroke-linecap="round" stroke-linejoin="round"></path>' +
            '<polyline id="Stroke-614" stroke="#000000" stroke-width="1.1" stroke-linecap="round" stroke-linejoin="round" points="22.58432 0.5038 11.52052 9.35 0.45562 0.4983"></polyline>' +
            '</g>' +
            '<path d="M24.0625,13.6598 L25.2417,12.9789 L23.5917,10.1211 L22.4026,10.8075 C21.8196,10.2729 21.1222,9.8747 20.35,9.6294 L20.35,8.25 L17.05,8.25 L17.05,9.6294 C16.2778,9.8747 15.5804,10.2729 14.9974,10.8075 L13.8083,10.1211 L12.1583,12.9789 L13.3375,13.6598 C13.1549,14.4826 13.1538,15.2141 13.3375,16.0413 L12.1605,16.7211 L13.8105,19.5789 L14.9974,18.8936 C15.5804,19.4271 16.2778,19.8253 17.05,20.0706 L17.05,21.45 L20.35,21.45 L20.35,20.0706 C21.1222,19.8253 21.8196,19.4271 22.4026,18.8936 L23.5895,19.5789 L25.2395,16.7211 L24.0625,16.0413 C24.2462,15.2141 24.2451,14.4826 24.0625,13.6598 L24.0625,13.6598 Z" id="Stroke-611" stroke="#000000" stroke-width="1.1" stroke-linejoin="round"></path>' +
            '</g>' +
            '</g>' +
            '</svg>';
    }

}


function NotificationsModel() {

    this.iconState = NotificationIconState.OUTLINE;  //initial state
    this.notificationItemList = [];
    this.clickSourceIsIcon = false;  //source of click is icon
    this.isMobile = false;

    this.iconClickTrackingDescription = function () {
        switch (this.iconState) {
            case NotificationIconState.OUTLINE:
                return "Click on notification icon outline";

            case NotificationIconState.FILLED:
                return "Click on notification icon filled";

            case NotificationIconState.FILLEDWITHDOT:
                return "Click on notification icon filled with dot";

            default:
                return "unknown";

        }
    };
};

var desktopDiv = "navbar-desktop-nc-toggle";
var mobileDiv = "navbar-mobile-nc-toggle";
var notificationsMobilePanel = "notificationsMobilePanel";
var notificationHeaderHeight = 80;
var desktopNotificationPageUrl = "/notifications";


function NotificationsTracker(queryStringParameterNameForANotificationSource) {

    this.queryStringParameterNameForANotificationSource = queryStringParameterNameForANotificationSource;
    this.trackingVars = "eVar23,eVar30,eVar77,list2,list3,eVar40,eVar28,eVar29";
    this.eVar147ControlOrTestOrNothing = "";

    this.trackIconClick = function (iconClickTrackingDescription) {
        this.trackEvent("event987", iconClickTrackingDescription);
    };

    this.trackNotificationLinkClick = function(notificationType, notificationClickChannel)
    {
        sessionStorage.setItem("NotificationType", notificationType);
        sessionStorage.setItem("NotificationClickChannel", notificationClickChannel);
        this.trackEvent("event74", "Notification Link Click");
    };



    this.isJBEUpdateFromTest = function ()
    {
        return (this.isUpdateDetailsPage() && this.isBrowserReload() === false && this.isInDormTest());
    };

    this.isUpdateDetailsPage = function()
    {
        return (location.pathname.toLowerCase().indexOf("/authenticated/default") > -1);
    };

    this.trackJBEUpdateClickThrough = function ()
        {
            this.trackEventAddEvars("event84",
            "JBE Update Clicked After Notification Click",
            [
                {
                    code: "eVar144",
                    value: this.sourceOfJBEClick()
                },
                {
                    code: "eVar147",
                    value: this.eVar147ControlOrTestOrNothing
                }
            ]
        );
    };



    this.isJBEDetailsUpdateSubmitted = function()
    {
        return (this.isUpdatedDetailsSubmittedPage() && this.isBrowserReload() === false);
    };

    this.isUpdatedDetailsSubmittedPage = function () {
        return ((location.pathname.toLowerCase().indexOf("/jobsbyemailsetupsubmit") > -1) && (location.search) && (location.search.toLowerCase().indexOf("isediting=") > -1) && (location.search.toLowerCase().indexOf("seqno=") > -1));
    };

    this.trackJBEUpdateSubmitted = function()
    {
        this.trackEventAddEvars("event85",
            "JBE Details Updated",
            [
                {
                    code: "eVar144",
                    value: this.sourceOfJBEClick()
                },
                {
                    code: "eVar147",
                    value: this.eVar147ControlOrTestOrNothing
                }
            ]
        );
    };



    this.checkAndTrackIfNotificationsListIsSourceOfJobClickAndOnJobDetailsPage = function () {
        var strEvent = "";
        if (this.isJobDetailsPage() &&
            this.isSourcedFromNotificationList()) {

            if (window.location.search.indexOf(SourceOfNotification.NOTIFICATIONPAGE) > -1) {
                strEvent += "RecommendedJob_CandidateHubPage";
            }
            else if (window.location.search.indexOf(SourceOfNotification.POPUPPANEL) > -1) {
                strEvent += "RecommendedJob_NotificationPanel";
            }
            if (strEvent !== "") {
                this.removeTrackingQueryString();
            }
        }
        return strEvent;
    };


    this.trackEventWithEvars = function (eventCode, eventDescription, eVarList) {
        if (typeof s !== 'undefined' && s !== null) {
            s.linkTrackVars = eVarList;
            s.linkTrackEvents = eventCode;
            s.events = eventCode;
            var linkName = eventDescription;
            s.tl(this, 'o', linkName);

            s.events = "";
            s.linkTrackEvents = "";
        }
    };


    this.trackEvent = function (eventCode, eventDescription) {
        if (typeof s !== 'undefined' && s !== null)
        {
            this.trackEventWithEvars(eventCode, eventDescription, this.trackingVars);
        }
    };

    this.trackEventAddEvars = function (eventCode, eventDescription, eVars) {
        if (typeof s !== 'undefined' && s !== null) {
            var eVarList = this.trackingVars;
            if (eVars !== null)
            {
                for (i = 0; i < eVars.length; i++)
                {
                    var eVar = eVars[i];
                    if (eVarList.toLowerCase().indexOf(eVar.code.toLowerCase()) === -1)
                    {
                        eVarList += "," + eVar.code;
                    }
                    s[eVar.code] = eVar.value;
                }
            }
            this.trackEventWithEvars(eventCode, eventDescription, eVarList);
            if (eVars !== null) {
                for (i = 0; i < eVars.length; i++) {
                    s[eVars[i].code] = "";
                }
            }
        }
    };

    this.trackOccurence = function (evarCode, occurenceTitle, occurenceDescription) {
        if (typeof s !== 'undefined' && s !== null) {
            var overrides = {};
            s.linkTrackVars = evarCode + "," + this.trackingVars;
            overrides[evarCode] = occurenceDescription;
            s.tl(true, 'o', occurenceTitle, overrides);
        }
    };

    this.removeTrackingQueryString = function () {
        if (history.pushState) {
            var querystring = this.stripTrackingParameterFromQueryString(window.location.search);
            var newUrl = window.location.protocol + "//" + window.location.host + window.location.pathname + querystring;
            window.history.pushState({ path: newUrl }, "", newUrl);
        }
    };

    this.stripTrackingParameterFromQueryString = function(queryString)
    {
        var result = queryString;
        for (var prop in SourceOfNotification)
        {
            if (SourceOfNotification.hasOwnProperty(prop))
            {
                var regex;
                if (SourceOfNotification.hasOwnProperty(prop))
                {
                    regex = new RegExp(this.queryStringParameterNameForANotificationSource +
                        '=' +
                        SourceOfNotification[prop]);
                    result = result.replace(regex, "");
                }
                regex = new RegExp("\\?\\&");
                result = result.replace(regex, "?");
                regex = new RegExp("\\&\\&");
                result = result.replace(regex, "&");
            }
        }
        return result;
    };

    this.isJobDetailsPage = function()
    {
        return (location.pathname.toLowerCase().indexOf("/job/") > -1);
    };

    this.isSourcedFromNotificationList = function()
    {
        return (window.location.search.indexOf(this.queryStringParameterNameForANotificationSource) > -1);
    };

    this.removeSpecificEvarsWhenSourceIsANotification = function () {
        if (typeof analytics !== 'undefined' && analytics != null) {
            analytics.ConversionType = "";
            analytics.ListingPosition = "";
            analytics.ConversionSource = "";
            analytics.ResultsListPage = "";
        }
    };

    this.notificationChannel = function () {
        var channel = sessionStorage.getItem("NotificationClickChannel");
        if (channel == null) {
            return "unknown";
        }
        else {
            return (channel === SourceOfNotification.NOTIFICATIONPAGE) ? "CandidateHubPage" : "NotificationPanel";
        }
    }

    this.sourceOfJBEClick = function()
    {
        return (this.eVar147ControlOrTestOrNothing === "B_PAP-234") ? "JBECredentials_" + this.notificationChannel() : "";
    }

    this.isInDormTest = function()
    {
        return (this.eVar147ControlOrTestOrNothing !== "");
    }

    this.isBrowserReload = function () {
        if (performance && performance.navigation && performance.navigation.type) {
            return (performance.navigation.type === 1);
        }
        return false;
    }
}


function NotificationsIconDisplayer(desktopNotificationIconDivId, mobileNotificationIconDivId) {
    this.desktopNotificationIconDivId = desktopNotificationIconDivId;
    this.mobileNotificationIconDivId = mobileNotificationIconDivId;
    this.iconIconSelector = "#" + this.desktopNotificationIconDivId + " > span, #" + this.mobileNotificationIconDivId + " > a";
    this.iconParentIdsSelector = "#" + this.desktopNotificationIconDivId + ", #" + this.mobileNotificationIconDivId;

    this.displayIconState = function (iconState) {
        var strClass = "nc-icon-filled-new";
        if (iconState === NotificationIconState.FILLED) {
            strClass = "nc-icon-filled";
        }
        if (iconState === NotificationIconState.OUTLINE) {
            strClass = "nc-icon-outline";
        }
        $(this.iconIconSelector).attr('class',
            "nc-icon " + strClass + " navbar-item");
    };
}

function NotificationsIconStateManager() {

    this.switchIconStateOnIconClick = function (iconState) {
        return (iconState === NotificationIconState.OUTLINE || iconState === NotificationIconState.FILLEDWITHDOT) ? NotificationIconState.FILLED : NotificationIconState.OUTLINE;
    };

    this.switchIconStateOnDocumentClick = function (iconState) {
        return (iconState === NotificationIconState.FILLED) ? NotificationIconState.OUTLINE : iconState;
    };
}

function NotificationsIconStateStorer() {

    this.localStorageItem = "NotificationIconState";

    this.storeIconState = function (iconState) {
        var iconStateToBeStored = (iconState === NotificationIconState.FILLED) ? NotificationIconState.OUTLINE : iconState;
        localStorage.setItem(this.localStorageItem, JSON.stringify(iconStateToBeStored));
    };

    this.retrieveIconState = function (defaultIconState) {
        var objIconState = JSON.parse(localStorage.getItem(this.localStorageItem));
        return (objIconState) ? parseInt(objIconState) : defaultIconState;
    };

}

function RecommenderJobsScraper() {

    this.scrapeJobs = function () {
        var localThisOrigin = this;

        var recommendedJobArray = [];
        if (!$('.rj-results-container').children()[0])
            return recommendedJobArray;

        $('.rj-job-container').each(function () {
            var recommendedJob = $(this);
            var extractedJob = localThisOrigin.scrapeJob(recommendedJob);

            if (extractedJob.title !== "" || extractedJob.link !== "") {
                recommendedJobArray.push(extractedJob);
            }
        });

        return recommendedJobArray;
    };

    this.scrapeJob = function (recommendedJob) {
        var extractedJob = {
            jobTitle: this.scrapeProperty(recommendedJob, ".rj-jobtitle > a > span", ".rj-jobtitle div > a", false),
            jobHref: this.scrapeProperty(recommendedJob, ".rj-jobtitle > a", ".rj-jobtitle div > a", true),
            jobLocation: this.scrapeProperty(recommendedJob,
                ".rj-details > li:nth-child(1) > span:nth-child(2)",
                "",
                false),
            jobSalary: this.scrapeProperty(recommendedJob,
                ".rj-details > li:nth-child(2) > span:nth-child(2)",
                "",
                false),
            jobCompany: this.scrapeProperty(recommendedJob,
                ".rj-details > li:nth-child(3) > span:nth-child(2)",
                "",
                false),
            jobType: this.scrapeProperty(recommendedJob,
                ".rj-details > li:nth-child(4) > span:nth-child(2)",
                "",
                false),
            infoMessage: this.scrapeProperty(recommendedJob, ".backfilled-info-message", "", false),
            notificationType: NotificationType.RECOMMENDEDJOB
        };

        extractedJob.jobLocationSalaryCompanyType = extractedJob.jobLocation.split(",")[0];
        extractedJob.jobLocationSalaryCompanyType += (extractedJob.jobSalary !== "" && extractedJob.jobSalary.toLowerCase() !== "not specified") ? " - " + extractedJob.jobSalary : "";
        extractedJob.jobLocationSalaryCompanyType += (extractedJob.jobCompany !== "") ? " - " + extractedJob.jobCompany : "";
        extractedJob.jobLocationSalaryCompanyType += (extractedJob.jobType !== "") ? " - " + extractedJob.jobType : "";

        return new RecommendedJobNotification(
            extractedJob.jobHref,
            extractedJob.jobTitle,
            extractedJob.infoMessage,
            extractedJob.jobLocationSalaryCompanyType,
            new Date());
    };

    this.scrapeProperty = function (recommendedJob, selector1, selector2, href) {
        if (!recommendedJob) {
            return "";
        }
        var prop = this.scrapeNode(recommendedJob, selector1, href);
        if (prop) {
            return prop.trim();
        }
        else {
            if (selector2 === "") {
                return "";
            }
            else {
                prop = this.scrapeNode(recommendedJob, selector2, href);
                if (prop) {
                    return prop.trim();
                }
                return "";
            }
        }
    };

    this.scrapeNode = function (recommendedJob, selector, href) {
        var node = recommendedJob.find(selector);
        if (node) {
            if (href) {
                var recommendedJobLink = node.attr("href");
                if (recommendedJobLink) {
                    return recommendedJobLink.split("?")[0];
                }
                return "";
            }
            else {
                if (node.text()) {
                    return node.text();
                }
                else {
                    return "";
                }
            }
        }
        else {
            return "";
        }
    };
}

var NotificationsABTestSegments =
{
    CONTROL: 0,
    TEST: 1
}

function NotificationsABTestManager(localStorageKey, probabilityOfBeingIncludedInTest)
{
    this.localStorageKey = localStorageKey;
    this.probabilityOfBeingIncludedInTest = probabilityOfBeingIncludedInTest;
    this.urlOverrideParameter = "notificationstestsegment";

    this.hasAlreadyBeenAssignedForTest = function () {
        var result = localStorage.getItem(this.localStorageKey);
        return (result) ? true : false;
    }

    this.previousTestSegment = function () {
        return localStorage.getItem(this.localStorageKey);
    }

    this.getNewSegment = function()
    {
        var rndDecimal = Math.random();
        var isInTest = (rndDecimal > (1 - this.probabilityOfBeingIncludedInTest))
            ? NotificationsABTestSegments.TEST
            : NotificationsABTestSegments.CONTROL;
        this.storeSegmentChoice(isInTest);
        return isInTest;
    }

    this.storeSegmentChoice = function(segmentChoice)
    {
        localStorage.setItem(this.localStorageKey, segmentChoice);
    }

    this.segmentChoiceIsOverridenInUrl = function()
    {
        return (location.search != null && location.search.toLowerCase().indexOf(this.urlOverrideParameter + "=") > -1);
    }

    this.segmentChoiceFromUrl = function()
    {
        if (location.search.toLowerCase().indexOf(this.urlOverrideParameter + "=") < 0) return -1;
        var result = (location.search.toLowerCase().indexOf(this.urlOverrideParameter + "=" + NotificationsABTestSegments.CONTROL) > -1) ? NotificationsABTestSegments.CONTROL: NotificationsABTestSegments.TEST;
        this.storeSegmentChoice(result);
        return result;
    }

}

var tempNotificationsTracker;

function JbeUpdateNotificationCreater() {

    this.linkToJBEPage = "/Authenticated/Default.aspx#MyJBE";
    this.titleText = "It's been 50+ days since your last activity. Are your alerts up to date?";
    this.linkText = "Update email criteria";
    this.dormantReactivationRegex = new RegExp("CLC_[A-Z]+_Dormant");
    this.jBEUpdateABTestManager = new NotificationsABTestManager("JbeUpdateNotification", 0.5); 
    this.testSegment = "";

    this.intTestSegment = function()
    {
        var result = -1;
        if (this.jBEUpdateABTestManager.segmentChoiceIsOverridenInUrl())
        {
            result = this.jBEUpdateABTestManager.segmentChoiceFromUrl();
        }
        else if (this.jBEUpdateABTestManager.hasAlreadyBeenAssignedForTest())
        {
            result = parseInt(this.jBEUpdateABTestManager.previousTestSegment());
        }
        else if (this.meetsCriteriaForDormantReactionTest())
        {
            result = this.jBEUpdateABTestManager.getNewSegment();
        }
        return result;
    }

    this.isInTest = function ()
    {
        return (this.intTestSegment() > -1);
    }

    this.setJbeTestTrackingDescription = function ()
    {
        this.testSegment = "";
        if (this.isInTest())
        {
            var result = this.intTestSegment();
            this.testSegment = (result === NotificationsABTestSegments.TEST) ? "B_PAP-234" : "A_PAP-234";
            this.setJBENotificationTestSegmentDirectlyOrThroughEvent();
        }
    }

    this.generateJbeUpdateNotificationsIfQualifies = function (currentNotificationList) {
        var newNotificationList = [];
        if (this.intTestSegment() === NotificationsABTestSegments.TEST && this.currentNotificationListContainsJBEUpdateAlready(currentNotificationList) === false && this.meetsCriteriaForDormantReactionTest())
        {
            newNotificationList.push(
                new JbeUpdateNotification(this.linkToJBEPage,
                    this.titleText,
                    "",
                    this.linkText,
                    new Date()));
        }
        return newNotificationList;
    }

    this.updateJbeNotificationExpiryDateIfQualifies = function (currentNotificationList) {
        if (this.intTestSegment() === NotificationsABTestSegments.TEST && this.currentNotificationListContainsJBEUpdateAlready(currentNotificationList) === true && this.meetsCriteriaForDormantReactionTest()) {
            for (var i = 0; i < currentNotificationList.length; i++)
            {
                if (currentNotificationList[i].notificationType === NotificationType.JBEUPDATE)
                {
                    currentNotificationList[i].dateCreated = new Date();
                }
            }
        } 
        return currentNotificationList;
    }

    this.meetsCriteriaForDormantReactionTest = function () {
        return (this.urlContainsDormantQualifier() && this.isExcludedBrand() === false);
    }

    this.urlContainsDormantQualifier = function ()
    {
        return this.testAQueryStringForDormantQualifier(location.search);
    }

    this.isExcludedBrand = function()
    {
        return this.testHostNameForExcludedBrand(window.location.hostname);
    }

    this.testHostNameForExcludedBrand = function(hostname)
    {
        var isExcluded = false;
        if (hostname == null)
        {
            return false;
        }
        var excludedBrands = ["jobsite.", "emedcareers.", "cityjobs.", "justengineers."];
        excludedBrands.forEach(function(item)
        {
            isExcluded = (hostname.toLowerCase().indexOf(item) > -1) ? true : isExcluded;
        });
        return isExcluded;
    }

    this.testAQueryStringForDormantQualifier = function(url)
    {
        return this.dormantReactivationRegex.test(url);
    }

    this.currentNotificationListContainsJBEUpdateAlready = function (currentNotificationItemList) {
        if (typeof currentNotificationItemList !== 'undefined' && currentNotificationItemList.length > 0) {
            for (var i = 0; i < currentNotificationItemList.length; i++) {
                if (currentNotificationItemList[i].notificationType === NotificationType.JBEUPDATE) {
                    return true;
                }
            }
        }
        return false;
    }

    this.assignJBENotificationTestSegment = function (segment) {

        {
            if (typeof s.eVar147 === "undefined" || s["eVar147"] == null || s["eVar147"].length === 0)
            {
                s["eVar147"] = segment;
            }
            else
            {
                s["eVar147"] += "," + segment;
            }
        }
    }

    this.setJBENotificationTestSegmentDirectlyOrThroughEvent = function () {
        if (typeof s !== "undefined") {
            this.assignJBENotificationTestSegment(this.testSegment);
        }
        else {
            tempNotificationsTracker = this;
            document.getElementById("body").addEventListener("analyticsPreSend",
                function()
                {
                    tempNotificationsTracker.assignJBENotificationTestSegment(tempNotificationsTracker.testSegment);
                }
            );
        };
    }

}

function NotificationsListLocalStorer() {

    this.localStorageItem = "recommendedJobsNotifications";

    this.storeNotificationsInLocalStorage = function (notificationsList) {
        localStorage.setItem(this.localStorageItem, JSON.stringify(notificationsList));
    };

    this.getNotificationsFromLocalStorage = function () {
        var localNotificationsList = JSON.parse(localStorage.getItem(this.localStorageItem));
        localNotificationsList = this.checkIfNotificationsAreNotOfCurrentForm(localNotificationsList);
        localNotificationsList = this.createListOfCorrectNotificationsObjects(localNotificationsList);
        return (localNotificationsList) ? localNotificationsList : [];
    };

    this.checkIfNotificationsAreNotOfCurrentForm = function (localNotificationList) {
        if (localNotificationList && localNotificationList.length > 0 && localNotificationList[0].hasOwnProperty("link") === false) {
            var translatedList = [];
            for (var i = 0; i < localNotificationList.length; i++) {
                translatedList.push(this.translateFromJobToNotification(localNotificationList[i]));
            }
            return translatedList;
        }
        else {
            return localNotificationList;
        }
    }

    this.createListOfCorrectNotificationsObjects = function (localNotificationList) {
        if (localNotificationList && localNotificationList.length > 0) {
            var translatedList = [];
            for (var i = 0; i < localNotificationList.length; i++) {
                var correctNotificationItem = this.createCorrectNotificationObject(localNotificationList[i]);
                if (correctNotificationItem) { translatedList.push(correctNotificationItem); }
            }
            return translatedList;
        }
        else {
            return localNotificationList;
        }
    }

    this.createCorrectNotificationObject = function (notificationItem) {
        if (notificationItem && notificationItem.hasOwnProperty("notificationType"))
        {
            var dateCreated =
                (typeof notificationItem.dateCreated === "undefined" || notificationItem.dateCreated == null)
                    ? new Date()
                    : new Date(notificationItem.dateCreated);
            dateCreated = (dateCreated.getFullYear() < 2019 || dateCreated > new Date()) ? new Date() : dateCreated;
            switch (notificationItem.notificationType) {
                case NotificationType.RECOMMENDEDJOB:
                    return new RecommendedJobNotification(notificationItem.link,
                        notificationItem.title,
                        notificationItem.subtitle,
                        notificationItem.body,
                        dateCreated);
                    break;

                case NotificationType.JBEUPDATE:
                    return new JbeUpdateNotification(notificationItem.link,
                        notificationItem.title,
                        notificationItem.subtitle,
                        notificationItem.body,
                        dateCreated);
                    break;

                default:
                    return new RecommendedJobNotification(notificationItem.link,
                        notificationItem.title,
                        notificationItem.subtitle,
                        notificationItem.body,
                        dateCreated);
                    break;
            }
        }
        else {
            return null;
        }
    }

    this.translateFromJobToNotification = function (job) {
        return new RecommendedJobNotification(
            job.jobHref,
            job.jobTitle,
            job.infoMessage,
            job.jobLocationSalaryCompanyType);
    }
}

function NotificationsListManager() {

    this.deDupeProperty = "link";
    this.maxListLength = 20;

    this.sortNotifications = function (notificationsList) {
        notificationsList.sort(function (notificationItem1, notificationItem2) {
            if (notificationItem1.notificationType !== notificationItem2.notificationType) {
                return (notificationItem1.notificationType === NotificationType.JBEUPDATE) ? -1 : 1;
            }
            return 0;
        }
        );
    }

    this.addNewNotifications = function (newNotifications, currentNotificationsList) {
        var amendedNotificationsList = [];
        if (currentNotificationsList) {
            amendedNotificationsList = newNotifications.concat(currentNotificationsList);
        }
        else {
            amendedNotificationsList = newNotifications;
        }

        amendedNotificationsList = this.removeDuplicates(amendedNotificationsList, this.deDupeProperty);
        amendedNotificationsList = amendedNotificationsList.slice(0, this.maxListLength);
        return amendedNotificationsList;
    };

    this.removeDuplicates = function (originalArray, prop) {
        var deDupedArray = [];
        var lookupObject = {};

        for (var i in originalArray) {
            if (originalArray.hasOwnProperty(i)) {
                lookupObject[originalArray[i][prop]] = originalArray[i];
            }
        }

        for (var x in lookupObject) {
            if (lookupObject.hasOwnProperty(x)) {
                deDupedArray.push(lookupObject[x]);
            }
        }
        return deDupedArray;
    };

    this.makeListBackWardCompatible = function(listOfNotifications)
    {
        for (var i = 0; i < listOfNotifications.length; i++) {
            var notification = listOfNotifications[i];
            if (typeof notification.notificationType === 'undefined' || notification.notificationType == null)
            {
                notification.notificationType = "Recommended Job";
            }
            if (typeof notification.jobLocationSalaryCompanyType === 'undefined' || notification.jobLocationSalaryCompanyType == null)
            {
                notification.jobLocationSalaryCompanyType = "";
                notification.jobLocationSalaryCompanyType += (typeof notification.jobLocation != 'undefined') ? notification.jobLocation.split(",")[0] : "";
                notification.jobLocationSalaryCompanyType += (typeof notification.jobSalary != 'undefined' && notification.jobSalary !== "" && notification.jobSalary.toLowerCase() !== "not specified") ? " - " + notification.jobSalary : "";
                notification.jobLocationSalaryCompanyType += (typeof notification.jobCompany != 'undefined' && notification.jobCompany !== "") ? " - " + notification.jobCompany : "";
                notification.jobLocationSalaryCompanyType += (typeof notification.jobType != 'undefined' && notification.jobType !== "") ? " - " + notification.jobType : "";
            }
        }
    };

    this.expireNotificationsFromList = function (localNotificationList) {
        if (localNotificationList && localNotificationList.length > 0) {
            var notExpiredList = [];
            for (var i = 0; i < localNotificationList.length; i++) {
                var notificationItem = localNotificationList[i];

                if (notificationItem && notificationItem.isExpired() === false) { notExpiredList.push(notificationItem); }
            }
            return notExpiredList;
        }
        else {
            return localNotificationList;
        }
    }

}

function NotificationsListDisplayer(mobileNotificationListDivId,
    desktopNotificationPageUrl,
    trackingManagerName) {
    this.mobileNotificationListDivId = mobileNotificationListDivId;
    this.desktopNotificationPageUrl = desktopNotificationPageUrl;
    this.trackingManagerName = trackingManagerName;

    this.maxNotifications = 20;
    this.notificationHeaderHeight = 80;
    this.notificationsPopUpSelector = ".nc-desktop-container  > .nc-container, .notification-list";
    this.notificationsPageListSelector = ".notifications-page-list";
    this.notificationsPageBackButtonId = "#notifications-page-back-button";
    this.notificationsPageMobileBackButtonSelector = ".notifications-mobile-backarrow";
    this.desktopNotificationMoreNotificationsMessage = "View all notifications";

    this.trackingLink = function (notificationType, notificationChannel) {
        return this.trackingManagerName + ".trackNotificationLinkClick('" + notificationType + "','" + notificationChannel + "')";
    }

    this.displayNotifications = function(notificationsList, sourceOfNotification, isMobilePanel)
    {
        var strHtml = this.noNotificationsMessageHtmlOnNotificationsPage();
        var targetHtmlDivId = this.choosePanelOrPageDivId(sourceOfNotification);

        if (sourceOfNotification === SourceOfNotification.POPUPPANEL)
        {
            if (isMobilePanel === false)
            {
                this.maxNotifications = 3;
            }
            else
            {
                this.switchMobileNotificationsPanelOnOrOff(true);
            }
        }
        else
        {
            this.displayBackButtonOnNotificationPage();
        }

        if (notificationsList && notificationsList.length > 0)
        {
            strHtml = "";
            var position = 1;

            for (var i = 0; i < Math.min(this.maxNotifications, notificationsList.length); i++)
            {
                if (notificationsList[i])
                {
                    strHtml += (sourceOfNotification === SourceOfNotification.POPUPPANEL)
                        ? this.displayNotificationInPanel(notificationsList[i], position)
                        : this.displayNotificationOnPage(notificationsList[i], position);
                    position++;
                }
            }
            strHtml += (sourceOfNotification === SourceOfNotification.POPUPPANEL && isMobilePanel === false)
                ? this.desktopNotificationMoreNotificationsHtmlLink()
                : "";
        }
        $(targetHtmlDivId).html(strHtml);
    };

    this.displayNotificationInPanel = function (notificationItem, position) {
        console.log(notificationItem);
        var strHtml = '<a class="notification-list-link" href="' +
            notificationItem.addNotificationQueryStringToUrl(SourceOfNotification.POPUPPANEL, position) +
            '"' +
            " onclick=\"" + this.trackingLink(notificationItem.notificationType, SourceOfNotification.POPUPPANEL) + "\"" +
            '>' +
            notificationItem.displayInNotificationPanel() +
            '</a>';
        return strHtml;
    }

    this.displayNotificationOnPage = function (notificationItem, position)
    {
        var strHtml = "<div class=\"notification-page-notification col-xs-12\">" +
            "<a href=\"" +
            notificationItem.addNotificationQueryStringToUrl(
                SourceOfNotification.NOTIFICATIONPAGE,
                position) +
            '\"' +
            " onclick=\"" + this.trackingLink(notificationItem.notificationType, SourceOfNotification.NOTIFICATIONPAGE) + "\"" +
            ">" +
            notificationItem.displayOnNotificationPage() +
            "</a>" +
            "</div>";
        return strHtml;
    }

    this.isNotificationsDisplayPage = function ()
    {
        return (location.pathname.toLowerCase().indexOf(this.desktopNotificationPageUrl.toLowerCase()) !== -1);
    }

    

    this.choosePanelOrPageDivId = function (sourceOfNotification) {
        return (sourceOfNotification === SourceOfNotification.POPUPPANEL)
            ? this.notificationsPopUpSelector
            : this.notificationsPageListSelector;
    }

    this.displayBackButtonOnNotificationPage = function () {
        if (document.referrer) {
            $(this.notificationsPageBackButtonId).attr("href", document.referrer);
            $(this.notificationsPageMobileBackButtonSelector).attr("href", document.referrer);
        }
        else {
            $(this.notificationsPageBackButtonId).hide();
        }
    }

    this.desktopNotificationMoreNotificationsHtmlLink = function () {
        return "<a class=\"notification-list-link\" href=\"" +
            this.desktopNotificationPageUrl +
            "\" >" +
            "<div class=\"notification-view-more\">" +
            this.desktopNotificationMoreNotificationsMessage +
            "</div>" +
            "</a>";
    }

    this.switchMobileNotificationsPanelOnOrOff = function (mobilePanelOnOrOff) {

        $("#" + this.mobileNotificationListDivId).attr("class", (mobilePanelOnOrOff) ? "slideInRight" : "slideOutRight");

        var heightList = $(window).height() - this.notificationHeaderHeight;

        $("#" + this.mobileNotificationListDivId + " .notification-list").css("height", heightList + "px");

        if (mobilePanelOnOrOff) {
            $("body").css("overflow-y", "hidden");
        }
        else {
            $("body").css("overflow-y", "auto");
        }

    };

    this.noNotificationsMessageHtmlForPanel = function ()
    {
        return '<div class="notification">' +
            '<div class="notification-icon welcome-notification">' +
            '</div>' +
            '<div class="notification-content">' +
            '<p class="notification-text"><br>You have no new notifications</p>' +
            '</div>' +
            '</div>';
    };

    this.noNotificationsMessageHtmlOnNotificationsPage = function () {
        return "<div class=\"notification-page-notification col-xs-12\">" +
            "<div class=\"row\">" +
            "<div class=\"notification-page-notification-details col-xs-12\">" +
            "<p style=\"padding-top:23px;padding-bottom:10px\" class=\"notification-page-notification-title\">You have no new notifications</p>" +
            "</div>" +
            "</div>" +
            "</div>";
    }

}

    var queryStringParameterNameForTheSourceOfNotification = "src_notifications";
    var notificationsModel = new NotificationsModel();

    var notificationsTracker = new NotificationsTracker(queryStringParameterNameForTheSourceOfNotification);
    var eVar144Value = notificationsTracker.checkAndTrackIfNotificationsListIsSourceOfJobClickAndOnJobDetailsPage();

    var recommenderJobsScraper = new RecommenderJobsScraper();
    var jBEUpdateNotificationCreater = new JbeUpdateNotificationCreater();

    var notificationsIconDisplayer = new NotificationsIconDisplayer(desktopDiv, mobileDiv);
    var notificationsIconStateManager = new NotificationsIconStateManager();
    var notificationsIconStateStorer = new NotificationsIconStateStorer();

    var notificationsListDisplayer = new NotificationsListDisplayer(notificationsMobilePanel, desktopNotificationPageUrl, "notificationsTracker");
    var notificationsListManager = new NotificationsListManager();
    var notificationsListLocalStorer = new NotificationsListLocalStorer();

    
function NotificationsController()
{

    this.fetchModelFromStorageAndPageProperties = function () {

        notificationsIconDisplayer.notificationHeaderHeight = $("#" + notificationsMobilePanel + " .notification-header").outerHeight();
        notificationsModel.isMobile = !$(desktopDiv).is(":visible");
        notificationsModel.notificationItemList = notificationsListLocalStorer.getNotificationsFromLocalStorage();
        notificationsModel.notificationItemList = notificationsListManager.expireNotificationsFromList(notificationsModel.notificationItemList);
        notificationsModel.notificationItemList = jBEUpdateNotificationCreater.updateJbeNotificationExpiryDateIfQualifies(notificationsModel.notificationItemList);
        notificationsListLocalStorer.storeNotificationsInLocalStorage(notificationsModel.notificationItemList);

        notificationsModel.iconState = notificationsIconStateStorer.retrieveIconState(NotificationIconState.OUTLINE);

        if (notificationsTracker.isJobDetailsPage() && eVar144Value !== "") { notificationsTracker.removeSpecificEvarsWhenSourceIsANotification(); }
        if (jBEUpdateNotificationCreater.isInTest()) { jBEUpdateNotificationCreater.setJbeTestTrackingDescription(); }
        notificationsTracker.eVar147ControlOrTestOrNothing = jBEUpdateNotificationCreater.testSegment;
        if (notificationsTracker.isJBEUpdateFromTest()) { notificationsTracker.trackJBEUpdateClickThrough(); }
        if (notificationsTracker.isJBEDetailsUpdateSubmitted() ) { notificationsTracker.trackJBEUpdateSubmitted(); }

    }

    this.addNewNotifications = function(lstNewNotifications)
    {
        if (lstNewNotifications.length > 0)
        {
            notificationsModel.iconState = NotificationIconState.FILLEDWITHDOT;
            notificationsModel.notificationItemList = notificationsListManager.addNewNotifications(lstNewNotifications, notificationsModel.notificationItemList);
            notificationsListManager.sortNotifications(notificationsModel.notificationItemList);
            if (notificationsListDisplayer.isNotificationsDisplayPage())
            {
                notificationsListDisplayer.displayNotifications(notificationsModel.notificationItemList,
                    SourceOfNotification.NOTIFICATIONPAGE,
                    notificationsModel.isMobile);
            }
            notificationsIconDisplayer.displayIconState(notificationsModel.iconState);
            notificationsIconStateStorer.storeIconState(notificationsModel.iconState);
            notificationsListLocalStorer.storeNotificationsInLocalStorage(notificationsModel.notificationItemList);
        }
    }

    this.iconClicked = function()
    {
        notificationsModel.clickSourceIsIcon = true;
        notificationsModel.isMobile = !$(desktopDiv).is(":visible");

        if (notificationsModel.iconState !== NotificationIconState.FILLED) {
            notificationsTracker.trackIconClick(notificationsModel.iconClickTrackingDescription());
        }

        notificationsModel.iconState = notificationsIconStateManager.switchIconStateOnIconClick(notificationsModel.iconState);
        notificationsIconStateStorer.storeIconState(notificationsModel.iconState);
    }

    this.documentOrGlyphonClick = function (isGlyphonClick) {
        if (notificationsModel.clickSourceIsIcon !== true) {
            notificationsModel.iconState = notificationsIconStateManager.switchIconStateOnDocumentClick(notificationsModel.iconState);
            notificationsIconDisplayer.displayIconState(notificationsModel.iconState);
            notificationsIconStateStorer.storeIconState(notificationsModel.iconState);
            if (isGlyphonClick && notificationsModel.isMobile) {
                notificationsListDisplayer.switchMobileNotificationsPanelOnOrOff(false);
            }
        }
        notificationsModel.clickSourceIsIcon = false;
    }

    this.pageView = function ()
    {
       notificationsIconDisplayer.displayIconState(notificationsModel.iconState);
       if (notificationsListDisplayer.isNotificationsDisplayPage()) {
           notificationsListDisplayer.displayNotifications(notificationsModel.notificationItemList,
               SourceOfNotification.NOTIFICATIONPAGE,
               notificationsModel.isMobile);
       }
    }

    this.iconPoweredPanelView = function()
    {
        notificationsIconDisplayer.displayIconState(notificationsModel.iconState);
        notificationsListDisplayer.displayNotifications(notificationsModel.notificationItemList, SourceOfNotification.POPUPPANEL, notificationsModel.isMobile);
    }

}

var notificationsController = new NotificationsController();

//Event management
$(function () {

    desktopDiv = "#" + desktopDiv;
    mobileDiv = "#" + mobileDiv;

    //Page load setup
    notificationsController.fetchModelFromStorageAndPageProperties();
    notificationsController.addNewNotifications(jBEUpdateNotificationCreater.generateJbeUpdateNotificationsIfQualifies(notificationsModel.notificationItemList));
    notificationsController.pageView();

    $(window).on("load", function () {
        setTimeout(function () {
            //Cycle through notification types
            notificationsController.addNewNotifications(recommenderJobsScraper.scrapeJobs());
            notificationsController.pageView();
            return true;
        }, 2000);
    });

    //Icon clicked
    $(notificationsIconDisplayer.iconParentIdsSelector).on('click', function () {
        notificationsController.iconClicked();
        notificationsController.iconPoweredPanelView();
    });

    //Document clicked
    $("body").on("click", function () {
        notificationsController.documentOrGlyphonClick(false);
    });


    //Glyphon clicked
    $(".notification-button-close").on("click", function () {
        notificationsController.documentOrGlyphonClick(true);
    });

    //Stop bubbling
    $(".nc-container, .notification-mobile-container, .nc-container, .notification-mobile-container").click(function (e) {
        e.stopPropagation();
    });
});
 

